import { CaseModel } from './case.model';
import { CaseProperties } from './caseproperties.model';
import { Department } from './department.model';
import { DepartmentDivision } from './departmentdivision.model';
import { HeaderDetails } from './headerdetails.model';
import { InvolvedAssigner } from './involvedassigner.model';
import { InvolvedPersonsInVisitsList } from './involvedpersonsinvisitslist.model';
import { InvolvedReporter } from './involvedreporter.model';
import { RemarkList } from './remarklist.model';

export class CaseDetailsProperty {
    $id: string;
    Case: CaseModel;
    CaseProperties: CaseProperties = new CaseProperties();
    CaseCode: string;
    IsRepairManagement?: any;
    IsABZ: boolean;
    Department: Department = new Department();
    DepartmentDivision: DepartmentDivision = new DepartmentDivision();
    HeaderDetails: HeaderDetails = new HeaderDetails();
    InvolvedAssigner: InvolvedAssigner = new InvolvedAssigner();
    InvolvedReporter: InvolvedReporter = new InvolvedReporter();
    RemarkList: RemarkList[];
    VisitsInfo?: any;
    InvolvedPersonsInVisitsList: InvolvedPersonsInVisitsList[];
    VisitsCanceledList?: any;

    public constructor(init?: Partial<CaseDetailsProperty>) {
        Object.assign(this, init);
    }
}

